import LocalesActionTypes from './locales.types';

export const setLocale = (locale) => ({
  type: LocalesActionTypes.SET_LOCALE,
  payload: locale,
});
